import { createStart, createMiddleware, createCsrfMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

// Sin functionMiddleware: ningún server fn público necesita el Bearer token
// que attachSupabaseAuth adjunta (eso solo lo usan las server fns admin,
// gateadas por requireAnyAdminAuth/requireCrmAccess/etc. — ver
// src/start.admin.ts). Registrarlo acá arrastraba el cliente Supabase
// completo (y por lo tanto @supabase/supabase-js) a CUALQUIER página
// pública, sin usarse nunca — ver split de Workers público/admin.
export const startInstance = createStart(() => ({
  requestMiddleware: [csrfMiddleware, errorMiddleware],
}));
